document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.header.style3 .full-mega-menu');
  if (!root) return;
  const header = root.closest('.header');
  const desktop = window.matchMedia('(min-width: 1068px)');
  const panels = [...root.querySelectorAll('.full-mega-menu--panel')];
  const items = [];
  let active = null;
  let keyboardMode = false;
  const mobileToggle = header.querySelector('.mobile-toggle-wrapper');
  mobileToggle?.addEventListener('toggle', (event) => {
    if (event.target !== mobileToggle || mobileToggle.open) return;
    mobileToggle.querySelectorAll('details.link-container').forEach((details) => {
      details.open = false;
      details.classList.remove('menu-opening', 'submenu-open');
    });
    mobileToggle.querySelectorAll('.mobile-menu-carousel--transition-inner-main, .mobile-menu-drawer').forEach((pane) => { pane.scrollTop = 0; });
    if (!document.body.matches('.open-cart, .open-search, .side-panel-open')) document.body.classList.remove('overflow-hidden');
  });

  root.querySelectorAll('.full-mega-menu--menu-primary').forEach((menu) => {
    const panel = root.querySelector(`.full-mega-menu--panel-${menu.dataset.category}`);
    menu.querySelectorAll(':scope > li').forEach((li) => {
      const link = li.querySelector('.full-mega-menu--link-parent');
      if (!link) return;
      link.removeAttribute('title');
      const target = panel && panel.querySelector(link.dataset.target);
      const item = { li, link, panel, target };
      items.push(item);
      if (target) {
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-controls', target.id);
      }
    });
  });

  const close = (restoreFocus = false) => {
    const previous = active;
    active = null;
    items.forEach(({ li, link, target }) => {
      li.classList.remove('is-active');
      if (target) {
        link.setAttribute('aria-expanded', 'false');
        target.classList.remove('is-expanded', 'is-closing');
        target.style.opacity = '0';
      }
    });
    panels.forEach((panel) => {
      panel.style.display = 'none';
      panel.style.opacity = '0';
    });
    if (!document.body.matches('.open-cart, .open-search, .side-panel-open') && !document.querySelector('.side-panel.active')) document.body.classList.remove('open-cc');
    if (document.body.classList.contains('template-index') && !header.classList.contains('is-sticky')) root.classList.remove('is-active');
    if (restoreFocus && previous) previous.link.focus();
  };

  const open = (item, focusEdge) => {
    if (!desktop.matches || !item.target) {
      close();
      return;
    }
    if (active !== item) {
      close();
      active = item;
      root.classList.add('is-active');
      document.body.classList.add('open-cc');
      item.li.classList.add('is-active');
      item.link.setAttribute('aria-expanded', 'true');
      item.panel.style.display = 'flex';
      item.panel.style.opacity = '1';
      item.target.classList.add('is-expanded');
      item.target.style.opacity = '1';
    }
    if (focusEdge) {
      const links = [...item.target.querySelectorAll('a[href]')];
      (focusEdge === 'last' ? links.at(-1) : links[0])?.focus();
    }
  };

  items.forEach((item) => {
    item.li.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') {
        keyboardMode = false;
        open(item);
      }
    });
    item.link.addEventListener('click', (event) => {
      if (!item.target) return;
      event.preventDefault();
      if (event.detail === 0 && active === item) close();
      else open(item);
    });
    item.link.addEventListener('keydown', (event) => {
      keyboardMode = true;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (!item.target) return;
        event.preventDefault();
        open(item, event.key === 'ArrowUp' ? 'last' : 'first');
      } else if (event.key === ' ' && item.target) {
        event.preventDefault();
        if (active === item) close();
        else open(item);
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        const siblings = items.filter((other) => other.li.parentElement === item.li.parentElement);
        const next = siblings[(siblings.indexOf(item) + (event.key === 'ArrowRight' ? 1 : -1) + siblings.length) % siblings.length];
        event.preventDefault();
        const wasOpen = !!active;
        next.link.focus();
        if (wasOpen) open(next);
      }
    });
  });

  root.addEventListener('mouseleave', () => { if (!keyboardMode) close(); });
  root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) close(); });
  root.addEventListener('keydown', (event) => {
    keyboardMode = true;
    if (!active || !active.target.contains(event.target)) return;
    const links = [...active.target.querySelectorAll('a[href]')];
    const index = links.indexOf(event.target.closest('a'));
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % links.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + links.length) % links.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = links.length - 1;
    if (next !== undefined) {
      event.preventDefault();
      links[next]?.focus();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (active) {
      event.preventDefault();
      close(true);
    } else {
      const mobile = header.querySelector('.mobile-toggle-wrapper[open]');
      if (mobile) {
        event.preventDefault();
        mobile.removeAttribute('open');
        mobile.classList.remove('active');
        if (!document.body.matches('.open-cart, .open-search, .side-panel-open')) document.body.classList.remove('overflow-hidden');
        mobile.querySelector('.mobile-toggle')?.focus();
      }
    }
  });
  document.addEventListener('pointerdown', (event) => {
    keyboardMode = false;
    if (active && !root.contains(event.target)) close();
  });
  desktop.addEventListener('change', () => close());
});
